import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentManagementActiveService {
  private readonly httpClient = inject(HttpClient);

  getPaymentManagementActive(): Observable<boolean> {
    const url = 'api/v1/payment-management/availability';

    return this.httpClient.get<boolean>(environment.portalApiUrl + url);
  }
}
